import AiHero from "./components/AiHero";
import AiFeature from "./components/AiFeature";
import AiVoice from "./components/AiVoice";
import AiFaq from "./components/AiFaq";

const AiCall = () => (
  <div className="overflow-hidden pt-[4.75rem] lg:pt-[5.25rem]">
    <title>AI Calling Agent - Automate Customer Engagement | BafarLabs</title>
    <meta
      name="description"
      content="Enhance your business communication with Bafar Labs' AI Calling Agent. Automate customer interactions, schedule appointments, and improve engagement with our advanced AI-powered calling solutions."
    />
    <meta
      name="keywords"
      content="AI Calling Agent, Automated Calling Solutions, AI Customer Engagement, Call Automation, AI Phone Agents, AI Appointment Scheduling, Bafar Labs AI Products"
    />
    <meta name="author" content="Bafar Labs" />
    <meta name="robots" content="index, follow" />
    <meta
      property="og:title"
      content="AI Calling Agent - Automate Customer Engagement | BafarLabs"
    />
    <meta
      property="og:description"
      content="Discover Bafar Labs' AI Calling Agent: an innovative tool that automates customer calls, enhances engagement, and streamlines communication."
    />
    <meta
      property="og:url"
      content="https://www.bafarlabs.com/ai-calling-agent"
    />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="https://www.bafarlabs.com/logo.png" />
    <meta property="twitter:card" content="summary_large_image" />
    <meta
      property="twitter:title"
      content="AI Calling Agent - Automate Customer Engagement | Bafar Labs"
    />
    <meta
      property="twitter:description"
      content="Explore Bafar Labs' AI Calling Agent: automate customer interactions and boost engagement with our AI-driven calling solutions."
    />
    <meta
      property="twitter:image"
      content="https://www.bafarlabs.com/logo.png"
    />
    <link rel="canonical" href="https://www.bafarlabs.com/ai-calling-agent" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />

    <AiHero />
    <AiFeature />
    <AiVoice />
    {/* <AiPricing />/ */}
    <AiFaq />
  </div>
);
export default AiCall;
